module.exports = __webpack_public_path__ + "static/media/Street-night.a94ba2b4.svg";